import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Catalogo from "./pages/Catalogo";
import CursoDetalle from "./pages/CursoDetalle";

const App = () => {
    return (
        <BrowserRouter>
            <Navbar />
            <main>
                <Routes>
                    <Route path="/" element={<Catalogo />} />
                    <Route path="/curso/:idRs" element={<CursoDetalle />} />
                </Routes>
            </main>
            <Footer />
        </BrowserRouter>
    );
};

export default App;
